import React from 'react';
import { CircularProgress, CircularProgressProps } from '@quillbot/design-system';
import { createStyles, makeStyles } from '@quillbot/design-system';

const useStylesFacebook = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    bottom: {
      color: theme.specialColors.CIRCULAR_PROGRESS,
    },
    top: {
      color: '#1a90ff',
      animationDuration: '550ms',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },

    roundedBox2: {
      position: 'relative',
      borderColor: '#fff',
      maxWidth: '115px',
      maxHeight: '115px',
      margin: 'auto',
      marginBottom: '12px',
    },
    spanStyle: {
      fontSize: '40px',
      position: 'absolute',
      top: '50%',
      fontWeight: 'bold',
      lineHeight: '31px',
      // color: '#4c9459',
      color: theme.palette.primary.main,
      left: '50%',
      transform: 'translate(-50%, -44%)',
      width: '100%',
      textAlign: 'center',
    },
    innerDiv: {
      fontSize: '14px',
      width: '100%',
      textAlign: 'center',
      display: 'block',
    },
  })
);

function CircularProgressWithLabel(
  // eslint-disable-next-line react/require-default-props
  props: CircularProgressProps & {
    value: number;
    valuetext?: string | React.ReactElement;
    bottomtext?: string;
    size?: number;
    thickness?: number;
    containerClassName?: string;
    spanClassName?: string;
    innerCircleVarient?: 'indeterminate' | 'determinate';
  }
) {
  const classes = useStylesFacebook();
  return (
    <div className={props.containerClassName || classes.roundedBox2}>
      <CircularProgress
        variant="determinate"
        className={classes.bottom}
        size={props.size || 115}
        style={{ position: 'absolute' }}
        thickness={props.thickness || 2}
        {...props}
        value={100}
      />
      <CircularProgress
        variant={props.innerCircleVarient || 'determinate'}
        size={props.size || 115}
        {...props}
        thickness={props.thickness || 2}
      />
      <span className={props.spanClassName || classes.spanStyle}>
        {props.valuetext || props.value} <div className={classes.innerDiv}>{props.bottomtext}</div>
      </span>
    </div>
  );
}

export default CircularProgressWithLabel;
